<div *ngIf="displayMode == 0" [class.out-of-stock-prod]="isOutOfStock()"
     [ngClass]="cssService.cardProductClass"
     (click)="openProdDial(prod, 'add')">

  <section *ngIf="isOutOfStock()">

    <!-- Out of stock badge prod.stock && prod.stock.count <= 0 -->
    <div class="out-of-stock-badge-grid text-align flex justify-center items-center">
      <span class="text-sm font-semibold">{{"unavailable"|translate}} </span>
    </div>

  </section>

  <section *ngIf="!isOutOfStock()">

    <!-- type menu Badge -->
    <div *ngIf="prod.product_type == 2"
         class="menu-badge-card-grid flex justify-center items-center bg-cyan-700 text-white p-4 rounded-t-md">
      <span class="text-sm font-semibold">{{'Menu'|translate}}</span>
    </div>

    <!-- type new Badge
    <div *ngIf="productService.getNewProduct(prod.date)"
         class="flex justify-center items-center text-align new  new-badge-card-grid "
         ngClass.xs="new-badge-card-pos-list-xs" [class.zindex-1]="isOutOfStock()">
      <span class="mat-caption boldest">{{'New'|translate}}</span>
    </div>-->

    <!-- Price period Badge
    <div *ngIf="prod.prices[0].id_price_period > 0" class="layout-padd-1 secondary clicked promo-badge-grid"
         (click)="myDials.openPromoShedulesDial(prod.prices[0].id_price_period); $event.stopPropagation()" angulartics2On="click"
         angularticsAction="openPromoShedulesDial" angularticsCategory="product">
      <span class="mat-caption boldest">{{productService.getPricePeriodName(prod.prices[0].id_price_period) | capitalize}}</span>
    </div>-->

  </section>

    <div class="h-full flex-1 flex flex-col hidden-overflow">

      <!-- Nom -->
      <div class="">
        <div class="text-base text-ellipsis text-gray-800 font-semibold">{{prod.display_lang.name}}</div>
      </div>

      <!-- Description -->
      <div class="truncate-text-2" *ngIf="prod.description">
        <p class="text-sm text-gray-500">{{prod.display_lang.description | removeHtmlFromString }}</p>
      </div>

      <!-- Comble le vide -->
      <div class="flex-1"></div>

      <!-- Prix prod.prices[0].price|discountVipFilter:merchantClient$:prod -->
      <div *ngIf="prod.prices[0].price && prod.prices[0].price > 0" class="pt-4">
          <span class="text-base text-gray-800">{{ prod.prices[0].price | priceFilter }}</span>
      </div>

    </div>

    <!-- Image Article -->
    <div *ngIf="prod.image.length > 0" class="pl-4">
      <img src="{{prod.image[1]}}" [ngClass]="cssService.productImageClass">
    </div>

</div>

<div *ngIf="displayMode == 1" [ngClass]="cssService.cardProductSquare"
     [class.out-of-stock-prod]="isOutOfStock()"
     (click)="openProdDial(prod, 'add')">

  <!-- Out of stock badge
  <div class="out-of-stock-badge-card full-w text-align" fxLayoutAlign="center center"
       *ngIf="prod.stock && prod.stock.count <= 0">
    <span class="mat-caption boldest">{{"unavailable"|translate}}</span>
  </div>-->

  <!-- type menu Badge

  <div *ngIf="prod.product_type==2 && (!prod.stock ||prod.stock && prod.stock.count > 0)"
       fxLayoutAlign="center center" class="text-align menu  menu-badge-card">
    <span class="mat-caption boldest">{{'Menu'|translate}}</span>
  </div>-->

  <!-- type new Badge
  <div *ngIf="productService.getNewProduct(prod.date) "
       fxLayoutAlign="center center" class="text-align new  new-badge-card-list " [class.zindex-1]="prod.stock && prod.stock.count <= 0">
    <span class="mat-caption boldest">{{'New'|translate}}</span>
  </div>-->

  <!-- Price period Badge
  <div *ngIf="prod.prices[0].id_price_period > 0" class="layout-padd-1 rad-bord secondary clicked promo-badge-card"
       (click)="myDials.openPromoShedulesDial(prod.prices[0].id_price_period); $event.stopPropagation()" angulartics2On="click"
       angularticsAction="openPromoShedulesDial" angularticsCategory="product">
    <span class="mat-caption boldest">{{ ProductService.getPricePeriodName(prod.prices[0].id_price_period) | capitalize}}</span>
  </div>-->

  <div class="relative w-full p-2">
    <img class="w-full h-full object-cover rounded-t-lg" src="{{ prod.image.length > 0 ? prod.image[2] : default_prod }}" alt="Nom du Produit 1">
  </div>

  <div class="px-4 pb-4 flex-1 flex flex-col gap-1.5 text-center">
    <div class="text-sm font-semibold text-gray-800 line-clamp-1 truncate">{{prod.display_lang.name}}</div>
    <div class="text-sm text-gray-600" *ngIf="prod.prices[0].price && prod.prices[0].price > 0">{{prod.prices[0].price | priceFilter}}</div>
  </div>

</div>
